__turbopack_context__.v({
  "active": "Player-module__ppcpbW__active",
  "border": "Player-module__ppcpbW__border",
  "controlPanel": "Player-module__ppcpbW__controlPanel",
  "controls": "Player-module__ppcpbW__controls",
  "fullscreenButton": "Player-module__ppcpbW__fullscreenButton",
  "playButton": "Player-module__ppcpbW__playButton",
  "player": "Player-module__ppcpbW__player",
  "progress": "Player-module__ppcpbW__progress",
  "soundButton": "Player-module__ppcpbW__soundButton",
  "video": "Player-module__ppcpbW__video",
  "volume": "Player-module__ppcpbW__volume",
});
